import React from 'react'
import { Box, Drawer, IconButton, Typography } from "@mui/material"
// icons
import CloseIcon from '@mui/icons-material/Close';

export default function ViewDiscrepancy({ open, TransitionComponent, handleClose, data }) {
  return (
    <Drawer
      open={open}
      TransitionComponent={TransitionComponent}
      keepMounted
      maxWidth='xs'
      fullWidth
      className="cus-drawer low-stock-products-drawer view-discrepancy-drawer"
      onClose={handleClose}
      anchor='right'
    >
      <Box p={2} className='drawer-head-sec d-flex align-item-center jc-s-btwn'>
        <Typography variant='h5' fontWeight='semibold'>Discrepancy Details</Typography>
        <IconButton onClick={handleClose} edge='end' size='small'>
          <CloseIcon fontSize='medium' />
        </IconButton>
      </Box>
      <Box p={{ xs: 2 }}>

        {/* Discrepancy Note */}
        <Typography variant='body2'>{data?.note}</Typography>

        {/* Discrepancy Image */}
        <Box mt={2}>
          {
            data?.photos?.map(photo => (
              <img key={photo} src={photo} alt="discrepancy" style={{ width: "auto", maxWidth: "100%" }} />
            ))
          }
        </Box>

      </Box>
    </Drawer>
  )
}
